<template>
  <div class="row">
    <div class="col-12">
      <card card-body-classes="table-full-width" no-footer-line>
        <div class="col-12">
          <h4> {{ book.title }} </h4>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-12 margin-bottom-15 margin-left-15">
              <div class="row text-align-center">
                <h6>Units</h6>
              </div>
            </div>
            <div class="col-12">
              <router-view/>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
export default {
  name: "Book",
  computed: {
    book () {
      return this.$store.getters['book/get']
    }
  },
  beforeMount () {
    this.$store.commit('book/setById', this.$route.params.id)
  },
  mounted () {
    if (!this.$store.getters['book/hasBook']) this.$router.go(-1)
  }
}
</script>
<style lang="scss" scoped>

.options button {
  margin: 0 5px;
}

.btn-small {
  padding: 5px 10px;
}

.list {
  border-bottom: 1px solid #ddd;
  margin-top: 10px;
}

</style>
